import Player from './player/index'
import MobileNavBar from './mobileNavBar.vue'
import VantUploadImage from './vantUploadImage.vue'
import Xgplayer from './xgplayer.vue'
import FileUpload from './FileUpload/index.vue'
const plugins = {
  Player,
  MobileNavBar,
  VantUploadImage,
  Xgplayer,
  FileUpload
}
export default {
  install(Vue) {
    Object.keys(plugins).forEach(key => {
      Vue.component(key, plugins[key])
    })
  }
}
